import { Navigate, Outlet } from 'react-router-dom';
import { useOpsContext } from './useOpsContext';
import { useOpsBriefingAccess } from '../../services/useOpsBriefingService';
import { OpsLoading } from './OpsStates';

/**
 * /opsBriefing 하위 라우트 접근 가드.
 *
 * ─────────────────────────────────────────────────────────────
 * 왜 필요한가
 * ─────────────────────────────────────────────────────────────
 * 이 라우트는 로그인만 확인하는 PrivateRoutes 아래에 조건 없이 달려 있었습니다.
 * GNB 에서 메뉴를 숨겨도, 로그인한 원장이 주소창에 `/opsBriefing/today` 를
 * 직접 치면 그대로 열렸습니다. 메뉴를 숨기는 것은 가드가 아닙니다.
 *
 * ─────────────────────────────────────────────────────────────
 * fail-closed
 * ─────────────────────────────────────────────────────────────
 * 판정 규칙은 accessGate.ts 에 있습니다. 여기서는 그 결과를 화면에 옮기기만 합니다.
 *
 *   판정 전(로딩) → **열지 않는다.** 뼈대만 보여주고 기다린다.
 *                   여기서 미리 Outlet 을 렌더하면 닫힌 센터에 화면이 한 번 번쩍이고,
 *                   그 사이 하위 페이지들이 게이트 안 엔드포인트를 불러 404 를 쏟는다.
 *                   반대로 곧바로 리다이렉트해도 안 된다 — 열린 센터의 원장이
 *                   매 진입마다 대시보드로 튕긴다.
 *   닫힘          → 대시보드로 돌려보낸다. replace 라서 뒤로가기로 되돌아오지 못한다.
 *   열림          → 통과.
 */

const OpsBriefingRouteGuard = () => {
    const ctx = useOpsContext();
    const { allowed, isResolving } = useOpsBriefingAccess(ctx);

    // 아직 모른다 — 열지도 닫지도 않는다
    if (isResolving) {
        return (
            <div className="flex w-full flex-col items-center bg-[#F4F5F7]">
                <div className="w-full max-w-[1440px]" style={{ marginTop: 108 }}>
                    <OpsLoading variant="page" />
                </div>
            </div>
        );
    }

    // 닫혔거나 조회에 실패했다 — 기능이 없는 것처럼 보이게 한다
    if (!allowed) return <Navigate to="/dash" replace />;

    return <Outlet />;
};

export default OpsBriefingRouteGuard;
